import React, {useEffect, useState} from 'react'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {authorizeWithStoreSlug, fetchPublicStoreSettingsBySlug} from '../../services/SellerServices'
import {getLocalData, setLocalData} from '../../services/StorageServices'
import {toaster} from '../../shared/PFToast'
import Step1Container from '../step1/Step1Container'
import { Spinner } from 'reactstrap'

const MockupGeneratorRedirect = () => {
    const [loadingGetSettings, setLoadingGetSettings] = useState(true)
    const [params] = useSearchParams()
    const navigate = useNavigate()
    const env = process.env.NODE_ENV
    // const path = env === 'development' ? process.env.REACT_APP_PATH : getLocalData('path')
    // const productId = env === 'development' ? process.env.REACT_APP_PRODUCT_ID : params.get('productId')
    const storeId = env === 'development' ? process.env.REACT_APP_STORE_ID : getLocalData('storeId')
    // const accessToken = env === 'development' ? process.env.REACT_APP_ACCESS_TOKEN : getLocalData('accessToken')

    // useEffect(() => {
    //     setLocalData('path', '')
    //     setLocalData('storeId', '')
    // }, [])

    const _fetchStoreSettings = async (storeId) => {
            if (!storeId) return
            const {success, data, message} = await fetchPublicStoreSettingsBySlug(storeId)
            if (!success) throw new Error(message)
            setLocalData('currentStoreSettings', JSON.stringify(data))

    }

    const _authorize = async (storeId) => {
            if (!storeId) return
            const {success, data, message} = await authorizeWithStoreSlug(storeId)
            if (!success) throw new Error(message)
            setLocalData('storeRoles', JSON.stringify(data.roles))
            setLocalData('storeSettings', JSON.stringify(data.settings))

    }

    const getStoreSetting = async (storeId) => {
        try {
            await _fetchStoreSettings(storeId)
            await _authorize(storeId)
        } catch (error) {
            setLocalData('storeRoles', "")
            setLocalData('storeSettings', "")
            setLocalData('currentStoreSettings', "")
            setLocalData('accessToken', "")
            setLocalData('path', "")
            setLocalData('storeId', "")
        } finally {
            setLoadingGetSettings(false)
        }
    }

    // useEffect(() => {
    //     setLocalData('path', path)
    //     setLocalData('accessToken', accessToken)
    // }, [path, accessToken])

    useEffect(() => {
        // setLocalData('storeId', storeId)
        setLocalData('storeRoles', JSON.stringify([]))
        getStoreSetting(storeId)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [storeId])

    // if (path && productId) {
    //     return (
    //         <div className="LoadingWrapper">
    //             <Spinner style={{color: '#007Bff'}} />
    //         </div>
    //     )
    // }
    if (loadingGetSettings)
        return (
            <div className="LoadingWrapper">
                <Spinner style={{color: '#007BFF'}} />
            </div>
        )

    return (
        <div>
            <Step1Container storeId={storeId} />
        </div>
    )
}

export default MockupGeneratorRedirect

